// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-favorites[data-v-8aec0978]{padding:2em;text-align:center;color:var(--color-text-light)}`, "",{"version":3,"sources":["webpack://./src/components/PublicFavoriteShareSideBar.vue"],"names":[],"mappings":"AACA,+BACC,WAAA,CACA,iBAAA,CACA,6BAAA","sourcesContent":["\n.no-favorites {\n\tpadding: 2em;\n\ttext-align: center;\n\tcolor: var(--color-text-light);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
